module.exports = __webpack_public_path__ + "media/images/help_correction_6-bbeb64b9e9cd7a89f186dec5f6d9971b.png";